// src/Pages/Announcements/RecentAnnouncements.jsx
import React from 'react';
import { Box, Paper, Typography, Chip, Button, CircularProgress, Divider } from '@mui/material';
import { useGetAnnouncementsQuery, useDiscardAnnouncementMutation } from '../../redux/thunks/announcements/announcements';
import { AnnouncementItems, STATUS_LABELS, PENDING } from './announcementFormat';

export default function RecentAnnouncements({ businessId }) {
  const { data, isLoading, isError, refetch } = useGetAnnouncementsQuery(
    { businessId, limit: 20 }, { skip: !businessId, pollingInterval: 15000 });
  const [discard, { isLoading: discarding }] = useDiscardAnnouncementMutation();

  const rows = data?.announcements || [];

  const handleDiscard = async (a) => {
    if (!window.confirm('Discard this update? Nothing more will be made from it.')) return;
    try { await discard({ announcementId: a.announcementId, businessId }).unwrap(); }
    catch { alert('Could not discard that. Please try again.'); refetch(); }
  };

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1.5 }}>Your recent updates</Typography>

      {isLoading && <Box sx={{ textAlign: 'center', py: 2 }}><CircularProgress size={24} /></Box>}
      {isError && <Typography variant="body2" color="error">Couldn't load your updates.</Typography>}
      {!isLoading && !isError && rows.length === 0 && (
        <Typography variant="body2" color="text.secondary">Nothing yet. What you tell us will show here.</Typography>
      )}

      {rows.map((a, i) => {
        const s = STATUS_LABELS[a.status] || { label: a.status, color: 'default' };
        return (
          <Box key={a.announcementId}>
            {i > 0 && <Divider sx={{ my: 1.5 }} />}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
              <Chip label={s.label} size="small" color={s.color} sx={{ height: 20, fontSize: '0.7rem' }} />
              <Typography variant="caption" color="text.secondary">
                {new Date(a.receivedAt).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}
              </Typography>
              {a.status !== 'discarded' && (
                <Button size="small" color="inherit" disabled={discarding}
                        onClick={() => handleDiscard(a)}
                        sx={{ ml: 'auto', textTransform: 'none', minWidth: 0, fontSize: '0.75rem' }}>
                  Discard
                </Button>
              )}
            </Box>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mb: 0.75 }}>"{a.rawText}"</Typography>
            {!PENDING.includes(a.status) && <AnnouncementItems items={a.items} dense />}
          </Box>
        );
      })}
    </Paper>
  );
}